import { c as _c } from "react-compiler-runtime";
import I18n from 'I18n';
import { useCallback, useMemo } from 'react';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import AsyncIFrame from 'collaboration-sidebar/components/AsyncUIIFrame';
import useWindowDimensions from 'collaboration-sidebar/hooks/useWindowDimensions';
import { IS_OPEN, TAB } from 'collaboration-sidebar/constants/CollaborationSidebarStateProperties';
import { IFRAME_INIT_TIMEOUT } from 'collaboration-sidebar/constants/iframe';
import { DEFAULT_WIDTH_CUTOFF } from 'collaboration-sidebar/constants/sidebar';
import { useCollaborationSidebarState } from 'collaboration-sidebar/hooks';
import useCollaborationSidebarProps from 'collaboration-sidebar/hooks/useCollaborationSidebarProps';
import { useIsTabParentRendered } from 'collaboration-sidebar/hooks/useIsTabParentRendered';
import ParentRenderedContent from 'collaboration-sidebar/components/ParentRenderedContent';
import { MSG_TYPE_MODAL_DIALOG_CLOSE } from 'ui-addon-iframeable/messaging/IFrameMessageTypes';
import { getEmbeddablePanelUrl } from 'collaboration-sidebar/utils/urls';
import ErrorMessage from 'collaboration-sidebar/components/errors/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import useHasNavCopilot from 'collaboration-sidebar/features/copilot/hooks/useHasNavCopilot';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CollaborationSidebarContent(t0) {
  "use memo";

  const $ = _c(49);
  const {
    isOpen: t1,
    iframeShouldRender: t2
  } = t0;
  const isOpen = t1 === undefined ? true : t1;
  const iframeShouldRender = t2 === undefined ? true : t2;
  const {
    scrollablePage,
    isOverlay,
    objectType,
    enabledFeatures,
    appName,
    ApprovalsContent,
    openLeftEditor,
    embeddedCommentsProps,
    commentableAssets,
    assetName,
    commentableAssetsTitle,
    isListingPage,
    objectId,
    hasUnreadComments,
    hasSidebarPermission,
    iframe: t3,
    onMessageRef,
    commentingDisabled,
    showSidebarHeader,
    hideCommentModeAndToggle,
    isLoadingFAS,
    embeddedCommentIndicatorOverride
  } = useCollaborationSidebarProps();
  const {
    handleSidebarInitError,
    isReady,
    handleReady,
    handleSidebarReadyError,
    IFrameError
  } = t3;
  const hasNavCopilot = useHasNavCopilot();
  const {
    tab,
    ctaUrl,
    collaborationSidebarState,
    onUpdateCollaborationSidebarState
  } = useCollaborationSidebarState();
  const {
    width
  } = useWindowDimensions();
  const isScreenWidthBelowThreshold = width < DEFAULT_WIDTH_CUTOFF;
  let t4;
  if ($[0] !== isScreenWidthBelowThreshold || $[1] !== onUpdateCollaborationSidebarState || $[2] !== openLeftEditor) {
    t4 = () => {
      onUpdateCollaborationSidebarState({
        [IS_OPEN]: false
      });
      if (openLeftEditor && isScreenWidthBelowThreshold) {
        openLeftEditor();
      }
    };
    $[0] = isScreenWidthBelowThreshold;
    $[1] = onUpdateCollaborationSidebarState;
    $[2] = openLeftEditor;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleClose = t4;
  let t5;
  if ($[4] !== handleClose || $[5] !== onMessageRef) {
    t5 = message => {
      if (message.payload.type === MSG_TYPE_MODAL_DIALOG_CLOSE) {
        handleClose();
      } else {
        if (onMessageRef.current) {
          onMessageRef.current(message);
        }
      }
    };
    $[4] = handleClose;
    $[5] = onMessageRef;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleOnMessage = t5;
  const isTabParentRendered = useIsTabParentRendered(tab);
  if (!isLoadingFAS && !hasSidebarPermission) {
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = /*#__PURE__*/_jsx(View, {
        padding: "300",
        children: /*#__PURE__*/_jsx(ErrorMessage, {
          illustration: "keys",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "collaborationSidebar.noSidebarPermission.title"
          }),
          message: "collaborationSidebar.noSidebarPermission.message"
        })
      });
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    return t6;
  }
  let t6;
  if ($[8] !== ApprovalsContent || $[9] !== enabledFeatures || $[10] !== isOpen || $[11] !== tab) {
    t6 = /*#__PURE__*/_jsx(ParentRenderedContent, {
      show: isOpen,
      tab: tab,
      enabledFeatures: enabledFeatures,
      ApprovalsContent: ApprovalsContent
    });
    $[8] = ApprovalsContent;
    $[9] = enabledFeatures;
    $[10] = isOpen;
    $[11] = tab;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== IFrameError || $[14] !== isOpen || $[15] !== isReady) {
    t7 = isOpen && !isReady && !IFrameError && /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: "100%",
      inlineSize: "100%",
      position: "absolute",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        "data-test-id": "sidebar-content-loading-spinner",
        layout: "centered"
      })
    });
    $[13] = IFrameError;
    $[14] = isOpen;
    $[15] = isReady;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== appName || $[18] !== assetName || $[19] !== collaborationSidebarState || $[20] !== commentableAssets || $[21] !== commentableAssetsTitle || $[22] !== commentingDisabled || $[23] !== ctaUrl || $[24] !== embeddedCommentIndicatorOverride || $[25] !== embeddedCommentsProps || $[26] !== enabledFeatures || $[27] !== handleOnMessage || $[28] !== handleReady || $[29] !== handleSidebarInitError || $[30] !== handleSidebarReadyError || $[31] !== hasNavCopilot || $[32] !== hasUnreadComments || $[33] !== hideCommentModeAndToggle || $[34] !== iframeShouldRender || $[35] !== isListingPage || $[36] !== isOpen || $[37] !== isOverlay || $[38] !== isReady || $[39] !== isTabParentRendered || $[40] !== objectId || $[41] !== objectType || $[42] !== scrollablePage || $[43] !== showSidebarHeader) {
    t8 = iframeShouldRender && /*#__PURE__*/_jsx(AsyncIFrame, {
      embeddedPassthruProps: {
        collaborationSidebarState,
        commentableAssets,
        assetName,
        commentableAssetsTitle,
        isListingPage,
        enabledFeatures,
        hasUnreadComments,
        commentingDisabled,
        appSupportedRoutesRegex: embeddedCommentsProps && embeddedCommentsProps.appSupportedRoutesRegex,
        showSidebarHeader,
        hideCommentModeAndToggle,
        hasNavCopilot,
        embeddedCommentIndicatorOverride
      },
      height: "100%",
      iframePassthruProps: Object.assign({
        "data-test-id": "collaboration-sidebar-embedded-iframe",
        "data-iframe-ready": isReady,
        title: I18n.text("collaborationSidebar.panel.sidebarTitle"),
        "aria-hidden": !isOpen
      }, !isOpen ? {
        tabIndex: "-1"
      } : {}),
      initTimeout: IFRAME_INIT_TIMEOUT,
      name: "collaboration-sidebar",
      onInitError: handleSidebarInitError,
      onReady: handleReady,
      onReadyError: handleSidebarReadyError,
      scrollablePage: scrollablePage,
      isOverlay: isOverlay,
      src: getEmbeddablePanelUrl({
        objectType,
        objectId,
        ctaUrl,
        appName,
        tab: collaborationSidebarState[TAB],
        enabledFeatures
      }),
      appName: appName,
      onMessage: handleOnMessage,
      className: isTabParentRendered ? "hidden" : undefined
    });
    $[17] = appName;
    $[18] = assetName;
    $[19] = collaborationSidebarState;
    $[20] = commentableAssets;
    $[21] = commentableAssetsTitle;
    $[22] = commentingDisabled;
    $[23] = ctaUrl;
    $[24] = embeddedCommentIndicatorOverride;
    $[25] = embeddedCommentsProps;
    $[26] = enabledFeatures;
    $[27] = handleOnMessage;
    $[28] = handleReady;
    $[29] = handleSidebarInitError;
    $[30] = handleSidebarReadyError;
    $[31] = hasNavCopilot;
    $[32] = hasUnreadComments;
    $[33] = hideCommentModeAndToggle;
    $[34] = iframeShouldRender;
    $[35] = isListingPage;
    $[36] = isOpen;
    $[37] = isOverlay;
    $[38] = isReady;
    $[39] = isTabParentRendered;
    $[40] = objectId;
    $[41] = objectType;
    $[42] = scrollablePage;
    $[43] = showSidebarHeader;
    $[44] = t8;
  } else {
    t8 = $[44];
  }
  let t9;
  if ($[45] !== t6 || $[46] !== t7 || $[47] !== t8) {
    t9 = /*#__PURE__*/_jsxs(Flex, {
      inlineSize: "100%",
      blockSize: "100%",
      children: [t6, t7, t8]
    });
    $[45] = t6;
    $[46] = t7;
    $[47] = t8;
    $[48] = t9;
  } else {
    t9 = $[48];
  }
  return t9;
}